//=========================================================
//  类型检查
//=========================================================

function isType(type) {
    return function (obj) {
        return {}.toString.call(obj) === "[object " + type + "]";
    }
}

/**
 * 类型检查 Undefined
 * @function
 * @param {*} obj 检查目标
 * @global
 * @returns {boolean}
 * */
let isUndefined = isType("Undefined");
/**
 * 类型检查 Object
 * @function
 * @param {*} obj 检查目标
 * @global
 * @returns {boolean}
 * */
let isObject = isType("Object");
/**
 * 类型检查 Number
 * @function
 * @param {*} obj 检查目标
 * @global
 * @returns {boolean}
 * */
let isNumber = isType("Number");
/**
 * 类型检查 Array
 * @function
 * @param {*} obj 检查目标
 * @global
 * @returns {boolean}
 * */
let isArray = Array.isArray || isType("Array");
/**
 * 类型检查 Function
 * @function
 * @param {*} obj 检查目标
 * @global
 * @returns {boolean}
 * */
let isFunction = isType("Function");
/**
 * 类型检查 String 验证 字符串字面量 和 new String()
 * @param {*} obj 检查目标
 * @global
 * @returns {boolean}
 * */
let isString = function (obj) {
    return isType("String")(obj) || obj instanceof String;
};
/**
 * 类型检查 Element
 * @param {*} obj 检查目标
 * @global
 * @returns {boolean}
 * */
let isElement = function (obj) {
    return /^\[object HTML\w*Element]$/.test({}.toString.call(obj));
};
/**
 * 类型检查 HTMLCollection NodeList
 * @param  {*} obj 检查目标
 * @global
 * @returns {boolean}
 * */
let isElementArray = function (obj) {
    return {}.toString.call(obj) == '[object HTMLCollection]' || {}.toString.call(obj) == '[object NodeList]';
};
/**
 * 类型检查 TableElement {thead|tbody|tr|td|th...}
 * @param {*} obj 检查目标
 * @global
 * @returns {boolean}
 * */
let isTableElement = function (obj) {
    return /^\[object HTMLTable\w*Element]$/.test({}.toString.call(obj));
};

//=========================================================
//  类型检查扩展
//=========================================================
/**
 * 多类型检查
 * 支持传入链式操作
 * @param variable 变量
 * @param {(object|Array)} options  [ function isString(){} , ... ] , { isString : function(){} , ... }
 * @param single 检查<strong>成功一次</strong>后退出
 * @returns {{}}
 * @global
 * @example
 *
 * isWhat(document.createElement('div')).isTypes(['string','element','array'],function () {
     *     console.log("str | elem |  array ");
     * }).isObject(function () {
     *     console.log("obj");
     * }).isString(function () {
     *     console.log("str2");
     * }).isEqual("peter",function () {
     *     console.log("peterE1");
     * },1).isEqual("peter",function () {
     *     console.log("peterE2");
     * });
 * // => str | elem |  array
 *
 */
let isWhat = function (variable, options, single) {
    // 类型检查名称
    let typeMap = {
        'isFunction': isFunction,   // function 是关键字，不能用啦
        'array': isArray, 'isArray': isArray,
        'object': isObject, 'isObject': isObject,
        'undefined': isUndefined, 'isUndefined': isUndefined,
        'string': isString, 'isString': isString,
        'number': isNumber, 'isNumber': isNumber,
        'element': isElement, 'isElement': isElement,
        'elementArray': isElementArray, 'isElementArray': isElementArray,
        'tableElement': isTableElement, 'isTableElement': isTableElement,
        'isEqual': null, // 自定义检查
        "isTypes": null   // 自定义检查
    };
    // ---1-->--2-->--3-->---
    // options : [ function isString(){} , ... ]
    single = single ? 1 : options && options.length;
    void(isArray(options) && Array.prototype.forEach.call(options, function (callback) {
        void(callback.name && typeMap[callback.name] && typeMap[callback.name](variable) && !function () {
            void(single-- && single >= 0 && callback());
        }());
    }));
    // options : { isString : function(){} , ... }
    void(isObject(options) && Object.forEachIn.call(options, function (callback, type) {
        void(type && typeMap[type] && typeMap[type](variable) && !function () {
            void(single-- && single >= 0 && callback());
        }());
    }));
    // ---1-->--{}.A()-->--{}.B()-->---
    let next = {};
    for (let an in typeMap) {
        if (!typeMap.hasOwnProperty(an)) continue;
        /**
         * @param {string} type
         * @param {...*} 之后的为可变参数
         */
        next[an] = function (type) {
            // 参数形式
            // 比较值cmpValue 成功回掉callback
            // 比较值cmpValue 成功回掉callback 成功后终结标记barrier
            // 成功回掉cmpValue 成功后终结标记callback
            return function (cmpData, callback, barrier) {
                // params : callback
                if (arguments.length === 1) callback = cmpData;
                // params : callback barrier
                if (arguments.length === 2 && !isFunction(callback)) {
                    barrier = callback;
                    callback = cmpData;
                }
                // isEqual处理
                if (type === "isEqual") {
                    (variable == cmpData) && callback();
                }
                // isType处理
                else if (type === "isTypes") {
                    // 检查类型数组中有对应值则返回
                    isArray(cmpData) && cmpData.slice(0).forEach(function (typeName) {
                        if (typeMap[typeName] && typeMap[typeName](variable)) {
                            callback();
                            cmpData.splice(0, cmpData.length);
                        }
                    });
                }
                // 普通类型检查处理
                else if (typeMap[type](variable) && callback) {
                    callback();
                }
                // 成功一次后终结处理
                if (barrier) {
                    for (let an in next) {
                        if (!next.hasOwnProperty(an)) continue;
                        next[an] = function () {
                            return next;
                        };
                    }
                }
                return next;
            };
        }(an);
    }
    return next;
};

export {isUndefined,isObject,isArray,isFunction,isString,isNumber,isElement,isElementArray,isTableElement,isWhat}
